import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Form, Skeleton } from "antd";
import { getDivisionName, shouldShowDivision } from "../../../../swzutils/UserPermissionsUtil";
import DivisionHelpLabel from "../../components/DivisionHelpLabel";
import DivisionAccessFormFields from "./DivisionAccessFormFields";
import TenantResource from "../tenants/api/TenantResource";
import { axiosErrorHandler } from "../../../../swzutils";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../store/slice/auth";
import { useAppSelector } from "../../../../store";
const DivisionAccessFormItem = ({ name = "divisionId", tenantId, disabled = false, required = false, allowMultiple = false, canBeRestricted = true }) => {
    const [divisionTenant, setDivisionTenant] = useState(null);
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useEffect(() => {
        if (!tenantId || selectedTenant?.id === tenantId) {
            setDivisionTenant(selectedTenant);
        }
        else if (tenantId && tenantId !== divisionTenant?.id) {
            fetchTenant(tenantId);
        }
    }, [selectedTenant?.id, tenantId]);
    const fetchTenant = (id) => {
        setNetworkRequestInProgress(true);
        TenantResource.get(id, setDivisionTenant, axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    if (networkRequestInProgress) {
        return (_jsx(Skeleton.Input, { active: true }));
    }
    if (!divisionTenant || !loggedInUser || !shouldShowDivision(loggedInUser, divisionTenant)) {
        return null;
    }
    const divisionName = getDivisionName(loggedInUser, selectedTenant);
    return (_jsx(Form.Item, { name: name, label: _jsx(DivisionHelpLabel, { title: divisionName }), rules: [{
                required,
                message: `Please select a ${divisionName}`,
            }], children: _jsx(DivisionAccessFormFields, { allowMultiple: allowMultiple, canBeRestricted: canBeRestricted, tenantId: divisionTenant.id, disabled: disabled }) }));
};
export default DivisionAccessFormItem;
